import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import { ErrorMessage as ErrorMessageContainer } from '@hookform/error-message';
import EnquiryInfoAddMessage from '../EnquiryInfoAddMessage';
import EnquiryCtas from '../EnquiryCtas';
import EnquiryTitle from '../EnquiryTitle';

const RequestQuote = ({ thread, send, venue }) => {
  const {
    formState: { errors },
    getValues,
    register,
  } = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
    defaultValues: {
      message: '',
    },
  });

  const onSubmit = () => {
    const quoteRequest = {
      _id: thread._id,
      message: getValues().message,
      attachments: [],
    };

    send({ type: 'SUBMIT_QUOTE_REQUEST', quoteRequest });
  };

  return (
    <Stack
      sx={{
        padding: '22px 12px 16px',
        background: '#fff',
        height: '100%',
        borderRadius: '8px',
      }}
      component='form'>
      <EnquiryTitle title={`Request to book ${venue.name || ''}`} />

      <Stack
        direction='column'
        spacing={1}
        className='enquiry-info'
        sx={{ pb: 2 }}>
        <Typography sx={{ fontSize: 13, color: '#000', lineHeight: 1.3 }}>
          Let the host know you&apos;re interested in booking their venue.
          They&apos;ll then send you a quote for you to approve to confirm your
          booking and secure the venue.
        </Typography>
        <EnquiryInfoAddMessage
          label=''
          placeholder='Please provide details about what is included in your quote, inclduing relevant package or menu information'
          register={register}
        />
        <ErrorMessageContainer
          errors={errors}
          name='message'
          as={ErrorMessage}
        />
      </Stack>

      <EnquiryCtas sx={{ mt: 'auto' }}>
        <Button
          onClick={() => onSubmit()}
          variant='contained'
          size='medium-large'
          form='confirm-price-form'
          color='primary'
          fullWidth>
          Request to book
        </Button>
        <Button
          size='medium-large'
          fullWidth
          variant='outlined'
          color='primary'
          onClick={() => send({ type: 'BACK' })}>
          Cancel
        </Button>
      </EnquiryCtas>
    </Stack>
  );
};

function ErrorMessage({ children }) {
  return <p className='error-message'>{children}</p>;
}

export default RequestQuote;
